const vatBases = (["invoice", "payment"] as const).map((e) => e);
export type VatBases = (typeof vatBases)[0];

export class VatBasis {
  constructor({ name }: { name: VatBases }) {
    this.name = name;
  }

  name: VatBases;

  static def: VatBasis = new VatBasis({ name: "invoice" });

  static fromString(str: string): VatBasis {
    const lowerStr = str.replace(/[_-]/g, "").toLowerCase();
    const name = vatBases.find((e) => e.toLowerCase() === lowerStr);
    if (name) {
      return new VatBasis({ name });
    }
    throw new Error("Invalid type of the VAT basis.");
  }

  static isValidString(str?: string): boolean {
    const lowerStr = str?.replace(/[_-]/g, "")?.toLowerCase();
    const name = vatBases.find((e) => e.toLowerCase() === lowerStr);
    return !!name;
  }

  toString(): string {
    return this.name;
  }
}
